import { useState } from 'react';
import { useSelector } from 'react-redux';
import { apiurl } from '../../utils/constants';

function CreateBillPrivateComm({ bill, onClose, onSaved }) {
	const [comm, setComm] = useState('');
	const [loadbtn, setLoadbtn] = useState(false);
	const [errors, setErrors] = useState({ comm: false });
	const { iden, mail } = useSelector((state) => state.user);

	const handleCreateComm = async () => {
		setLoadbtn(true);
		const newErrors = {};
		if (comm.trim() === '') newErrors.comm = true;
		setErrors(newErrors);

		if (Object.values(newErrors).some(Boolean)) {
			setLoadbtn(false);
			return;
		}

		try {
			const response = await fetch(apiurl + 'tableINSE', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					table: 'bil__post',
					fiels: 'note, bill, publ, auth, mess, iden_form',
					vals: `1,'${bill.docu}',now(),'${iden}','${comm}', ${bill.iden_form}`,
					exist: '1=0',
				}),
			});

			if (!response.ok) {
				throw new Error('Error en la solicitud POST');
			}

			const responseData = await response.json();
			if (responseData[0]?.error === 1) {
				setLoadbtn(false);
				return;
			}

			if (typeof onSaved === 'function') {
				onSaved(comm);
			}
			onClose();
		} catch (error) {
			setLoadbtn(false);
			console.error('Error al crear comentario privado:', error);
		}
	};

	return (
		<form>
			<orm-modal>
				<dialog open>
					<h2>Agregar comentario privado</h2>
					<fieldset>
						<textarea
							value={comm}
							onChange={(e) => setComm(e.target.value)}
							className={errors.comm ? 'error' : ''}
						/>
					</fieldset>
					<table>
						<tfoot>
							<tr>
								<td></td>
								<td>
									<input type="button" value="Cancelar" onClick={onClose} />
									<input type="button" value="Agregar" onClick={handleCreateComm} disabled={loadbtn} />
								</td>
							</tr>
						</tfoot>
					</table>
				</dialog>
			</orm-modal>
		</form>
	);
}

export default CreateBillPrivateComm;